import React, { useEffect } from 'react';
import { Title, Meta, Link } from 'react-head';
import HeroSection from './HeroSection2';
import ServicesGrid from './ServicesGrid/ServicesGrid';
import WhyChooseTrinitySection from './WhyChooseTrinity/WhyChooseTrinitySection';
import ProcessTimeline from './ProcessTimeline/ProcessTimeline';
import ContactForm from './ContactForm/ContactForm';

const Tradefinance = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Trade Finance | Bank Instrument Merchant | Financial instrument Agent';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) metaDescription.setAttribute('content', 'Trusted SBLC Provider for Global Growth, Trade Finance agents providing BG, SBLC, LC, and surety bonds through top-tier financial institutions globally.');
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) metaKeywords.setAttribute('content', 'SBLC, sblc providers, sblc vs lc, sblc bank, sblc in banking, sblc letter of credit, BANK SECURITIES, BG, DLC, CORPORATE SERVICES, INVESTMENTS, FINANCIAL ADVISORY, DUE DILIGENCE, PAYMASTER, ESCROW, sblc lease, sblc for lease, sblc monetization, sblc purchase, sblc mt760, sblc funding process, sblc cost, sblc commision, sblc issuer, swift, sblc swift mt760, mt799, pre advice, rwa, offshore bank account, offshore company, offshore bank account opening, offshore banking, offshore online bank account');
  }, []);

  return (
    <>
      {/* SEO Meta Tags */}
      <Title>Trade Finance Services | Bank Instrument Merchant | Financial instrument Agent</Title>
      
      <Meta name="description" content="Secure, efficient financial instruments to power your international trade and business expansion. Expert trade finance solutions including bank guarantees, LC, SBLC, and surety bonds." />
      
      <Meta name="keywords" content="Trade Finance Services, bank guarantee, LC, Bank Comfort Letter, SBLC, letter of credit, Surety bond, trade finance, international trade, business expansion, banking instruments" />
      
      <Meta name="robots" content="index, follow" />
      <Meta name="author" content="Trinity Financing" />
      
      <Link rel="canonical" href="https://trinityfinancing.com/tradefinance" />
      
      {/* Open Graph Tags */}
      <Meta property="og:type" content="website" />
      <Meta property="og:url" content="https://trinityfinancing.com/tradefinance" />
      <Meta property="og:title" content="Trade Finance Services | Bank Instrument Merchant | Trinity Financing" />
      <Meta property="og:description" content="Secure, efficient financial instruments to power your international trade and business expansion. Expert trade finance solutions." />
      <Meta property="og:image" content="https://trinityfinancing.com/micro-finance.jpg" />
      <Meta property="og:image:width" content="1200" />
      <Meta property="og:image:height" content="630" />
      <Meta property="og:site_name" content="Trinity Financing" />
      
      {/* Twitter Card Tags */}
      <Meta name="twitter:card" content="summary_large_image" />
      <Meta name="twitter:title" content="Trade Finance Services | Bank Instrument Merchant" />
      <Meta name="twitter:description" content="Secure, efficient financial instruments to power your international trade and business expansion." />
      <Meta name="twitter:image" content="https://trinityfinancing.com/micro-finance.jpg" />

      {/* JSON-LD Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FinancialService",
          "name": "Trinity Financing Agent",
          "description": "Global financial agency & trade finance solutions provider",
          "url": "https://trinityfinancing.com",
          "logo": "https://trinityfinancing.com/logo.png",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Ground flr, Bldg 4, 50 Constantia Blvd, Constantia Kloof",
            "addressLocality": "Johannesburg",
            "postalCode": "1709",
            "addressCountry": "ZA"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "-26.1314",
            "longitude": "27.9328"
          },
          "email": "finance.support@trinityfinancing.com",
          "areaServed": {
            "@type": "Country",
            "name": "Worldwide"
          },
          "slogan": "Your Pathway to $1M-$500B Project Funding",
          "foundingDate": "2009",
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.9",
            "reviewCount": "500"
          }
        })}
      </script>

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Service",
          "serviceType": "Trade Finance Solutions",
          "provider": {
            "@type": "FinancialService",
            "name": "Trinity Financing Agent"
          },
          "areaServed": {
            "@type": "Country",
            "name": "Worldwide"
          },
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "Trade Finance Services",
            "itemListElement": [
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Letter of Credit (LC)"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Bank Guarantee"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Surety Bond"
                }
              },  
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Bank Comfort Letter"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Performance Guarantee"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Advance Payment Guarantee"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Standby Letter of Credit (SBLC)"
                }
              }
            ]
          }
        })}
      </script>

      {/* Page Content */}
      <div>
        <HeroSection />
        <ServicesGrid />
        <WhyChooseTrinitySection />
        <ProcessTimeline />
        <ContactForm />
      </div>
    </>
  );
};

export default Tradefinance;